<div class="page-container">
  <div class="card">
    <h1 class="card-title">System Logs</h1>
    <hr class="divider">

    <!-- Filter Buttons -->
    <div class="filter-bar">
      <span class="filter-label">Filter by Level:</span>
      <div class="filter-buttons">
        <button *ngFor="let level of levels"
                class="filter-btn"
                [class.active]="selectedLevel === level"
                [ngClass]="level === 'ALL' ? '' : getLevelClass(level)"
                (click)="setFilter(level)">
          {{ level }}
        </button>
      </div>
      <!--
        Compact view (default) collapses per-file INFO chatter into
        per-stage summaries so large runs stay readable. Verbose fetches
        the raw stream for support/debugging.
      -->
      <div class="filter-buttons" style="margin-left:auto">
        <button class="filter-btn"
                [class.active]="compact"
                (click)="setCompact(true)"
                title="Collapse per-file chatter into stage summaries">
          Compact
        </button>
        <button class="filter-btn"
                [class.active]="!compact"
                (click)="setCompact(false)"
                title="Show every raw log entry">
          Verbose
        </button>
      </div>
      <button class="btn btn-secondary btn-sm" (click)="loadLogs()">
        Refresh
      </button>
    </div>

    <!-- Loading -->
    <div class="loading" *ngIf="isLoading">
      <div class="spinner"></div>
      <p>Loading logs...</p>
    </div>

    <!-- Error -->
    <div class="error-banner" *ngIf="errorMessage">
      <p>{{ errorMessage }}</p>
    </div>

    <!-- No Logs Message -->
    <div class="empty-state" *ngIf="!isLoading && logs.length === 0 && !errorMessage">
      <p>No logs available yet. Process some files to see logs here.</p>
    </div>

    <!-- Logs Table -->
    <div class="table-container" *ngIf="!isLoading && logs.length > 0">
      <table class="logs-table">
        <thead>
          <tr>
            <th class="col-time">Timestamp</th>
            <th class="col-level">Level</th>
            <th class="col-process">Process</th>
            <th class="col-file">File</th>
            <th class="col-message">Message</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of filteredLogs" [ngClass]="getLevelClass(log.level)">
            <td class="col-time">{{ log.timestamp }}</td>
            <td class="col-level">
              <span class="level-badge" [ngClass]="getLevelClass(log.level)">{{ log.level }}</span>
            </td>
            <td class="col-process">{{ log.process }}</td>
            <td class="col-file">{{ log.file || '—' }}</td>
            <td class="col-message">{{ log.message }}</td>
          </tr>
        </tbody>
      </table>

      <p class="log-count">Showing {{ filteredLogs.length }} of {{ logs.length }} entries</p>
    </div>
  </div>
</div>
